// @flow
import { LayoutActionTypes } from './constants';

import * as layoutConstants from '../../constants/layout';

const INIT_STATE = {
    layoutColor: layoutConstants.LAYOUT_COLOR_LIGHT,
    layoutType: layoutConstants.LAYOUT_VERTICAL,
    layoutWidth: layoutConstants.LAYOUT_WIDTH_FLUID,
    leftSideBarTheme: layoutConstants.LAYOUT_COLOR_LIGHT,
    leftSideBarType: layoutConstants.LEFT_SIDEBAR_TYPE_FIXED,
};

type LayoutAction = { type: string, payload?: string | null };

type State = {
    layoutType: string,
    layoutColor: string,
    layoutWidth: string,
    leftSideBarTheme: string,
    leftSideBarType: string,
};

const Layout = (state: State = INIT_STATE, action: LayoutAction): any => {
    switch (action.type) {
        case LayoutActionTypes.CHANGE_LAYOUT_COLOR:
            return {
                ...state,
                layoutColor: action.payload,
            };
        case LayoutActionTypes.CHANGE_SIDEBAR_THEME:
            return {
                ...state,
                leftSideBarTheme: action.payload,
            };
        case LayoutActionTypes.CHANGE_SIDEBAR_TYPE:
            return {
                ...state,
                leftSideBarType: action.payload,
            };
        default:
            return state;
    }
};

export default Layout;
